import Vue from 'vue';
import { deskManager } from "./DeskManager.controller.js";

Vue.prototype.$sac = new Vue ({
    methods: {
        startFlowSac(source) {
            deskManager.dwhatToggle(source);
        }
    }
});